
  export default {
    props: ['popular_tools']
  }
